import { useTranslation } from 'next-i18next'

export default function OrLine({
  lineColor = 'bg-white',
  textColor = 'text-white',
  textGapClassName = 'mx-8',
  className = '',
  text,
}: {
  className?: string
  lineColor?: string
  textColor?: string
  textGapClassName?: string
  text?: string
}): React.ReactElement {
  const { t } = useTranslation('generics')

  return (
    <div className={`${className} w-full flex items-center`}>
      <div className={`flex-1 h-px ${lineColor}`} />
      <small className={`${textGapClassName} ${textColor}`}>{text ?? t('or')}</small>
      <div className={`flex-1 h-px ${lineColor}`} />
    </div>
  )
}
